module.exports = __webpack_public_path__ + "static/media/saved_search.42d25852.png";